import { render, staticRenderFns } from "./SocialDataModal.vue?vue&type=template&id=01f487ad"
import script from "./SocialDataModal.vue?vue&type=script&lang=js"
export * from "./SocialDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports